(() => {
  const dialog = document.getElementById('glow-cart');
  const form = document.getElementById('offer-form');
  if (!dialog || !form) return;
  const t = JSON.parse(document.getElementById('gc-translations').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const config = window.PRODUCT_CONFIG || {};
  let busy = false, cart, opener;
  const error = document.getElementById('gc-error');
  const items = document.getElementById('gc-items');
  const upsell = document.getElementById('gc-upsell');
  const checkout = document.getElementById('gc-checkout');
  const offer = document.getElementById('glow-gold-offer');
  const goldId = Number(offer?.dataset.goldVariant || 0);
  const goldAccept = offer?.querySelector('[data-gbo-accept]');
  const goldSkip = offer?.querySelector('[data-gbo-skip]');
  const goldError = offer?.querySelector('[data-gbo-error]');
  let offerSeen = false;
  try {offerSeen = sessionStorage.getItem('glow-gold-offer-shown-v1')==='yes';} catch (_) {}
  const hasGold = () => cart?.items?.some(item=>Number(item.variant_id)===goldId);
  const hasBauble = () => cart?.items?.some(item=>Number(item.variant_id)===Number(config.variantId) && item.quantity>0);
  let goldFlow='cart';
  const previewOfferTest=new URLSearchParams(location.search).get('gb_bump_test')==='1';
  function offerEligible() { return !!offer && goldId>0 && offer.dataset.available==='true' && hasBauble() && !hasGold() && (!offerSeen || previewOfferTest); }
  function showNextStep(){
    const toCheckout=goldFlow==='checkout';
    goldFlow='cart';
    closeGoldOffer();
    if(toCheckout){location.assign(root+'checkout');}
    else open();
  }
  const video=offer?.querySelector('#gbo-original-video');
  const sound=offer?.querySelector('[data-gbo-sound]');
  sound?.addEventListener('click',()=>{
    if(!video)return;
    video.muted=!video.muted;
    sound.textContent=video.muted?'Sound on':'Sound off';
    sound.setAttribute('aria-label',video.muted?'Turn on video sound':'Mute video');
    if(video.paused)video.play().catch(()=>{});
  });
  function showGoldOffer() {
    offerSeen=true;
    try {sessionStorage.setItem('glow-gold-offer-shown-v1','yes');} catch (_) {}
    if(!offer.open) {offer.showModal();document.documentElement.classList.add('gbo-open');}
    if(video?.querySelector('source[src]'))video.play().catch(()=>{});
  }
  function closeGoldOffer() {
    if(offer?.open) offer.close();
    document.documentElement.classList.remove('gbo-open');
    video?.pause();
  }
  const el = (tag, text, cls) => { const n = document.createElement(tag); if(text) n.textContent = text; if(cls) n.className = cls; return n; };
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:cart?.currency || config.currency || 'GBP'}).format(value / 100);
  async function api(path, data) {
    const response = await fetch(root + path, {credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},...(data ? {method:'POST',body:JSON.stringify(data)} : {})});
    const result = await response.json();
    if(!response.ok) throw new Error(result.description || result.message || t.error);
    return result;
  }
  function open() { if(!dialog.open) {opener=document.activeElement; dialog.showModal(); document.documentElement.classList.add('gc-open');} }
  function close() {dialog.close();document.documentElement.classList.remove('gc-open');opener?.focus({preventScroll:true});}
  function render() {
    document.querySelectorAll('[data-cart-count]').forEach(n => n.textContent=cart.item_count);
    items.replaceChildren();
    if(!cart.item_count) items.append(el('p',t.empty,'gc-empty'));
    cart.items.forEach(item => {
      const row=el('article',null,'gc-item');
      if(item.image) {const img=el('img');img.src=item.image;img.alt=item.product_title;img.width=80;img.height=80;row.append(img);}
      const detail=el('div',null,'gc-detail');detail.append(el('h3',item.product_title));
      if(item.variant_title && item.variant_title!=='Default Title') detail.append(el('small',item.variant_title));
      const price=el('p');if(item.original_line_price>item.final_line_price)price.append(el('s',money(item.original_line_price)));price.append(el('strong',money(item.final_line_price)));detail.append(price);
      (item.line_level_discount_allocations || []).forEach(d=>detail.append(el('small',d.discount_application.title,'gc-discount')));
      const controls=el('div',null,'gc-quantity');
      for(const [label,quantity] of [['−',item.quantity-1],['+',item.quantity+1]]) {const b=el('button',label);b.type='button';b.setAttribute('aria-label',`${label} ${t.quantity}: ${item.product_title}`);b.addEventListener('click',()=>change(item.key,quantity));controls.append(b);if(label==='−')controls.append(el('span',String(item.quantity)));}
      const remove=el('button',t.remove,'gc-remove');remove.type='button';remove.addEventListener('click',()=>change(item.key,0));controls.append(remove);detail.append(controls);row.append(detail);items.append(row);
    });
    const quantity=cart.items.filter(i=>String(i.variant_id)===String(config.variantId)).reduce((sum,i)=>sum+i.quantity,0);
    document.getElementById('gc-message').textContent=quantity>=4?t.four:[t.start,t.one,t.two,t.three][quantity];
    document.getElementById('gc-progress').value=Math.min(quantity,4);
    upsell.hidden=quantity>=4 || config.available===false;
    upsell.textContent=quantity===3?t.gift:t.add;
    document.getElementById('gc-total').textContent=money(cart.total_price);
    checkout.disabled=!cart.item_count;
    dialog.querySelector('.gc-wallets')?.toggleAttribute('hidden',!cart.item_count);
  }
  function lock(value) {
    busy=value; dialog.setAttribute('aria-busy',String(value));
    dialog.querySelectorAll('button:not([data-cart-close])').forEach(n=>n.disabled=value);
    form.querySelectorAll('button[type="submit"]').forEach(n=>n.disabled=value || config.available===false);
    document.getElementById('sticky-checkout-button').disabled=value || config.available===false;
    if(!value) checkout.disabled=!cart?.item_count;
  }
  async function action(work, reveal=true, onSuccess=null) {
    if(busy) return;
    lock(true);error.hidden=true;
    try {
      await work();
      cart=await api('cart.js');
      render();
      if(onSuccess) onSuccess();
      else if(reveal) open();
      document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
    } catch(e) {
      closeGoldOffer();
      open();
      error.textContent=e.message || t.error;
      error.hidden=false;
    } finally {lock(false);}
  }
  const change=(id,quantity)=>action(()=>api('cart/change.js',{id,quantity}));
  upsell.addEventListener('click',()=>action(()=>api('cart/add.js',{items:[{id:config.variantId,quantity:1}]})));
  document.querySelectorAll('[data-cart-open]').forEach(b=>b.addEventListener('click',()=>action(async()=>{})));
  dialog.querySelector('[data-cart-close]').addEventListener('click',close);
  dialog.addEventListener('cancel',e=>{e.preventDefault();close();});
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left || e.clientX>r.right)close();}});
  form.addEventListener('submit',e=>{
    const direct=e.submitter?.id==='glow-buy-now';
    e.preventDefault();
    const data=new FormData(form);
    action(
      ()=>api('cart/add.js',{items:[{id:data.get('id'),quantity:Number(data.get('quantity')) || 1}]}),
      false,
      ()=>{
        goldFlow=direct?'checkout':'cart';
        if(offerEligible()){
          if(goldSkip) goldSkip.textContent=direct?'No thanks, continue to checkout':'No thanks, view my cart';
          showGoldOffer();
        } else showNextStep();
      }
    );
  });
  goldSkip?.addEventListener('click',showNextStep);
  goldAccept?.addEventListener('click',async()=>{
    if(busy || !goldId)return;
    goldAccept.disabled=true;
    goldSkip.disabled=true;
    goldError.hidden=true;
    try {
      await api('cart/add.js',{items:[{id:goldId,quantity:1}]});
      cart=await api('cart.js');
      render();
      document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
      showNextStep();
    } catch(e) {
      goldError.textContent=e.message || t.error;
      goldError.hidden=false;
    } finally {
      goldAccept.disabled=false;
      goldSkip.disabled=false;
    }
  });
  offer?.addEventListener('cancel',e=>{
    e.preventDefault();
    showNextStep();
  });
  api('cart.js').then(result=>{cart=result;render();}).catch(()=>{});
})();
